import { render, staticRenderFns } from "./IfacesTab.vue?vue&type=template&id=4e3ce73a&"
import script from "./IfacesTab.vue?vue&type=script&lang=js&"
export * from "./IfacesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports